import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Instagram, Facebook, Twitter, Anchor } from "lucide-react";
const socialLinks = [{
  name: "Instagram",
  icon: Instagram,
  url: "#",
  handle: "@themissyvonne",
  description: "Daily catches and life on the deck."
}, {
  name: "Facebook",
  icon: Facebook,
  url: "#",
  handle: "The Miss Yvonne Seafood",
  description: "Community updates and local events."
}, {
  name: "Twitter",
  icon: Twitter,
  url: "#",
  handle: "@missyvonne1965",
  description: "Quick updates from the captain."
}];
export default function SocialMedia() {
  return <section id="social-media-links" className="bg-background py-24 md:py-40 px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 bottom-0 left-8 md:left-16 w-[1px] bg-border opacity-50 hidden md:block" />

      <div className="max-w-[1440px] mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
          
          {}
          <div className="lg:col-span-7 relative group">
            {}
            <div className="absolute -left-6 top-12 -rotate-90 origin-left text-muted-foreground font-mono text-xs tracking-widest hidden xl:block">
              {"30° 24' 42\" N / 88° 49' 42\" W"}
            </div>

            <div className="border border-border p-2 bg-card shadow-lg transition-transform duration-500 group-hover:scale-[1.02]">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_social_feature.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_social_feature.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_social_feature.png-wvc-sizes" alt="The Miss Yvonne crew hauling in a fresh catch on the Gulf Coast" className="w-full h-full object-cover grayscale-[20%] contrast-125" loading="lazy" />
              </AspectRatio>
            </div>
            
            {}
            <div className="absolute -bottom-4 -right-4 w-8 h-8 bg-background border border-border flex items-center justify-center shadow-sm">
              <Anchor className="w-4 h-4 text-primary" />
            </div>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col gap-8">
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                  {"04 //"}
                </span>
                <span className="font-mono text-xs uppercase tracking-widest text-primary font-medium">
                  {"The Logbook"}
                </span>
              </div>
              
              <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground leading-tight tracking-tight">
                {"Join the Crew"}
              </h2>
              
              <p className="font-sans text-lg text-muted-foreground leading-relaxed">
                {"Follow our journey from the Gulf Coast to your table. Experience the daily catches, maritime history, and life aboard The Miss Yvonne."}
              </p>
            </div>

            <div className="flex flex-col gap-4 mt-4">
              {socialLinks.map((link, i) => {
              const Icon = link.icon;
              return <div data-index={i} key={link.name}>
                    <Link to={link.url} className="block group/link">
                      <div className="flex items-center justify-between p-4 border border-border bg-card hover:border-primary transition-colors duration-150 shadow-sm">
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 rounded-md bg-background border border-border flex items-center justify-center group-hover/link:bg-primary group-hover/link:text-primary-foreground transition-colors duration-150">
                            <Icon className="w-5 h-5" />
                          </div>
                          <div>
                            <h3 className="font-default font-semibold text-foreground text-lg">
                              {link.name}
                            </h3>
                            <p className="font-mono text-xs text-muted-foreground tracking-wide">
                              {link.handle}
                            </p>
                          </div>
                        </div>
                        <Button variant="ghost" size="icon" className="opacity-0 group-hover/link:opacity-100 transition-opacity duration-150 text-primary">
                          <span className="sr-only">{"Visit " + link.name}</span>
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5">
                            <path d="M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                          </svg>
                        </Button>
                      </div>
                    </Link>
                  </div>;
            })}
            </div>

            <div className="mt-6 pt-6 border-t border-border flex items-center justify-between">
              <span className="font-mono text-xs text-muted-foreground uppercase tracking-widest">
                {"Stay Connected"}
              </span>
              <div className="w-16 h-[1px] bg-primary"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}